import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import withContext from '../../withContext';

class Header extends React.Component {
    handleReviewsClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const reviewsSection = document.getElementById('reviews-section');
        
        if (reviewsSection) {
            const rect = reviewsSection.getBoundingClientRect();
            const scrollTop = window.pageYOffset + rect.top - 80;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        } else {
            // On other page: go home, then we'll scroll via state flag
            this.props.history.push('/');
            window.__needsReviewsScroll = true;
        }
    }

    handleLogoClick = (e) => {
        // If already on homepage, scroll to top
        if (window.location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.lastScrollY = 0;
        }
    }

    constructor(props) {
        super(props);
        this.headerRef = React.createRef();
        this.lastScrollY = 0;
        this.isHomePage = window.location.pathname === '/';
        this.isInitialMount = !window.__headerMounted;
        this.hideTimeout = null;
        this.isNavigatingHome = false;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.scheduleAutoHide = this.scheduleAutoHide.bind(this);
        this.cancelAutoHide = this.cancelAutoHide.bind(this);
        this.getHeaderElement = this.getHeaderElement.bind(this);
    }

    isMobile() {
        return window.innerWidth <= 768;
    }

    handleMouseMove(e) {
        if (!this.isHomePage || !this.headerRef.current || this.isMobile()) return;
        
        const header = this.headerRef.current;
        const isHidden = header.classList.contains('header-hidden');
        
        // If at top and header is hidden and mouse is near top, show it
        if (isHidden && window.scrollY < 50 && e.clientY < 100) {
            header.classList.remove('header-hidden');
        }
    }

    handleScroll() {
        if (!this.isHomePage || !this.headerRef.current || this.isMobile()) return;
        const currentScrollY = window.scrollY;
        const header = this.headerRef.current;

        // Hide on downward scroll past threshold
        if (currentScrollY > this.lastScrollY && currentScrollY > 50) {
            header.classList.add('header-hidden');
        } else if (currentScrollY < this.lastScrollY) {
            // Show on upward scroll
            header.classList.remove('header-hidden');
        }

        this.lastScrollY = currentScrollY;
    }

    scheduleAutoHide() {
        // Auto-hide disabled
        return;
    }

    cancelAutoHide() {
        if (this.isNavigatingHome && window.scrollY < 50) return;
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
    }

    getHeaderElement() {
        return this.headerRef.current || document.querySelector('.mainHeader');
    }

    componentDidMount() {
        window.__headerMounted = true;
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('mousemove', this.handleMouseMove);
    }

    componentDidUpdate(prevProps) {
        const prevPath = prevProps.location?.pathname;
        const currentPath = this.props.location?.pathname;
        if (prevPath !== currentPath) {
            sessionStorage.setItem('prevPath', prevPath);
            this.isHomePage = currentPath === '/';
            if (currentPath === '/') {
                if (this.headerRef.current) {
                    this.headerRef.current.classList.remove('header-hidden');
                }
                
                // Check for hash and scroll to it
                const hash = window.location.hash;
                if (hash) {
                    setTimeout(() => {
                        const element = document.querySelector(hash);
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                        }
                    }, 100);
                } else {
                    window.scrollTo(0, 0);
                }
                
                this.lastScrollY = 0;
                this.isNavigatingHome = true;
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('mousemove', this.handleMouseMove);
        this.cancelAutoHide();
    }

    render() {
        const { cart } = this.props.context;
        const isHomePage = this.props.location.pathname === '/';
        const headerClass = `mainHeader stickynavbar${isHomePage && this.isInitialMount ? ' header-slide-in' : ''}`;
        
        return (
            <>
                <div ref={this.headerRef} className={headerClass}>
                    <div className="mainHeader-left">
                        <h1 className="Yekaterina">
                            <Link to="/" onClick={this.handleLogoClick}>
                                <span className="d-none d-md-inline">Katya Zhmud</span>
                                <span className="d-md-none">Zhmud</span>
                            </Link>
                        </h1>
                    </div>
                    <div className="mainHeader-center">
                        <Navbar expand="md" className="flex-row p-0" id="SecondHeader" sticky="top" collapseOnSelect>
                            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                            <Navbar.Collapse className="w-100" justify id="responsive-navbar-nav">
                                <Nav
                                    className="navbar-links-row"
                                    activeKey="/"
                                >
                                    <div className="navbar-links-group">
                                        <Nav.Item>
                                            <Nav.Link className="MainLinksHeader" eventKey="link-home">
                                                <Link to="/" id="link-home" className="nav-link shineactive" onClick={this.handleLogoClick}>
                                                    <h1>Home</h1>
                                                </Link>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="MainLinksHeader" eventKey="link1">
                                                <Link to="/shop" id="link1" className="nav-link shineactive">
                                                    <h1>Shop</h1>
                                                </Link>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="MainLinksHeader" eventKey="link3">
                                                <Link to="/gallery" id="link3" className="nav-link shineactive">
                                                    <h1>Gallery</h1>
                                                </Link>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="MainLinksHeader" onClick={this.handleReviewsClick} style={{ cursor: 'pointer' }}>
                                                <a id="link2" className="nav-link shineactive" style={{ cursor: 'pointer' }}>
                                                    <h1>Reviews</h1>
                                                </a>
                                            </Nav.Link>
                                        </Nav.Item>
                                        {/* <Nav.Item>
                                            <Nav.Link className="MainLinksHeader" eventKey="link-about">
                                                <Link to="/about" id="link-about" className="nav-link shineactive">
                                                    <h4>About</h4>
                                                </Link>
                                            </Nav.Link>
                                        </Nav.Item> */}
                                        <Nav.Item>
                                            <Nav.Link className="MainLinksHeader" eventKey="link-contact-home">
                                                <Link to="/#contact-section" id="link-contact" className="nav-link shineactive" onClick={(e)=>{ const el=document.getElementById('contact-section'); if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth'}); } }}>
                                                    <h1>Contact</h1>
                                                </Link>
                                            </Nav.Link>
                                        </Nav.Item>
                                        {/* <Nav.Item>
                                            <Nav.Link className="MainLinksHeader" eventKey="link4">
                                                <a href="/#contact-section" id="link4" className="nav-link shineactive" onClick={(e)=>{ e.preventDefault(); const el=document.getElementById('contact-section'); if(el){ el.scrollIntoView({behavior:'smooth'});} else { window.location.href='/#contact-section'; } }}>
                                                    <h4>Commissions</h4>
                                                </a>
                                            </Nav.Link>
                                        </Nav.Item> */}
                                    </div>
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                    </div>
                    <div className="mainHeader-right">
                        <Nav.Item className="CartNavItem">
                            <Nav.Link className="MainLinksHeader" eventKey="link5">
                                <Link to="/cart" id="link5" className="nav-link shineactive d-flex align-items-center">
                                    <h1 className="mb-0 mr-2">Cart</h1>
                                    <div style={{position: 'relative', display: 'inline-block'}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 16 16" style={{display: 'block'}}>
                                            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                        </svg>
                                        {Object.keys(cart).length >= 1 && (
                                            <span className="badge badge-pill badge-outline-primary" style={{position: 'absolute', top: '-6px', right: '-8px', minWidth: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', padding: '0 5px'}}>
                                                {Object.keys(cart).length}
                                            </span>
                                        )}
                                    </div>
                                </Link>
                            </Nav.Link>
                        </Nav.Item>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(withContext(Header));
